import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class FaturasService extends Service{

  protected url: string = this.dominio+"/adm/faturas/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  alteraStatus(id, status, data_pagamento = null, notifica = true) {
    let headers = this.getHeaderLogado();
    let url = this.url + id + '/status/' + status;

    if (!notifica) {
      url += '/nao-notifica';
    }

    return this.http.put(url, { "data_pagamento": data_pagamento }, { headers })
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  // solicita o envio da fatura por email
  enviaPdfEmail(id_fatura, elem){
    let headers = this.getHeaderLogado();

    return this.http.post(this.url + id_fatura+'/notificar', JSON.stringify(elem),{headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });

  }

  editarFaturaAvulsa(values, h){

  }

  adicionarFaturaAvulsa(values){

  }

  faturarFichasAvulsas(fichas: string[], data: string){
    let headers = this.getHeaderLogado();
    return this.http.post(this.url + 'faturar-fichas-avulsas', JSON.stringify({fichas, data}), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  faturarLaudosAvulsos(laudos: string[], data: string){
    let headers = this.getHeaderLogado();
    return this.http.post(this.url + 'faturar-laudos-avulsos', JSON.stringify({laudos, data}), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  faturarLaudosCdAvulsos(laudos: string[], data: string){
    let headers = this.getHeaderLogado();
    return this.http.post(this.url + 'faturar-laudos-cd-avulsos', JSON.stringify({laudos, data}), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  faturarLaudosTecnicosAvulsos(laudos: string[], data: string){
    let headers = this.getHeaderLogado();
    return this.http.post(this.url + 'faturar-laudos-tecnicos-avulsos', JSON.stringify({laudos, data}), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  faturarCertificadosNacionaisAvulsos(certificados: string[], data: string, taxa_laboratorial: string){
    let headers = this.getHeaderLogado();
    return this.http.post(this.url + 'faturar-certificados-nacionais-avulsos', JSON.stringify({certificados, data, taxa_laboratorial}), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  faturarLaudosCdValorFixo(id_cliente: string, data_de: string, data_ate: string, data: string = null, valor_fixo: string = null){
    let headers = this.getHeaderLogado();
    return this.http.post(this.url + 'faturar-laudos-cd-valor-fixo', JSON.stringify({id_cliente, data_de, data_ate, data, valor_fixo}), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  getControleFinanceiro(data_de: string, data_ate: string, id_cliente: string = '') {
    let headers = this.getHeaderLogado();
    let url = this.url + 'controle-financeiro?data_de=' + data_de + '&data_ate=' + data_ate;
    if (id_cliente) {
      url += '&id_cliente=' + id_cliente;
    }
    return this.http.get(url, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  getRelatorioCompleto(data_de: string, data_ate: string) {
    let headers = this.getHeaderLogado();
    let url = this.url + 'relatorio-completo?data_de=' + data_de + '&data_ate=' + data_ate;
    return this.http.get(url, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  getDashboardData(mes: number, ano: number) {
    let headers = this.getHeaderLogado();
    let url = this.url + 'dashboard?mes=' + mes + '&ano=' + ano;
    return this.http.get(url, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  alterarValorFixo(id: string, valor: string) {
    let headers = this.getHeaderLogado();
    return this.http.put(this.url + id + '/alterar-valor-fixo', JSON.stringify({ valor }), { headers })
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/faturas/faturas.service.ts